import { transaction } from '@/stores/transaction';
import { format } from 'date-fns';
import API from '@/api/api-main';

class ServiceTrading {
    _salesPriceCache = null;
    _salesPriceCacheTime = 0;
    // Helper method để lấy exchangeRate từ store
    getExchangeRate() {
        const transactionStore = transaction();
        return transactionStore.exchangeRate || 0;
    }

    default_transaction() {
        const user = JSON.parse(localStorage.getItem('user'))?.appUser || null;
        return user.bizSectors[0]?.itmsGrpCode == 'VTS' ? this.getInvoiceJewelry(0) : this.getInvoice(0);
    }

    getInvoice(index) {
        const url = 'ARInvoice';
        return {
            id: index,
            name: 'Hóa đơn',
            Products: [],
            Customer: '',
            status: 'I',
            nameUrl: url,
            urlAdd: url + '/add',
            addAndPayMent: '',
            urlUpdate: url,
            itemType: 'SellItem',
            payload: {
                id: 0,
                invoiceCode: '',
                shiftId: 0,
                cardId: 0,
                cardCode: '',
                cardName: '',
                total: 0,
                totalPayment: 0,
                note: '',
                status: null,
                itemDetail: [],
                address: {},
                paymentMethod: [],
                nationality: '',
                dateOfBirth: null,
                citizenId: '',
                phone: '',
                typeDoc: '',
                country: ''
            },
            type: 'HOA_DON'
        };
    }

    getInvoiceJewelry(index) {
        const url = 'ARJewerly';
        return {
            id: index,
            name: 'Hóa đơn',
            Products: [],
            Customer: '',
            status: 'I',
            nameUrl: url,
            urlAdd: url + '/add',
            addAndPayMent: '',
            urlUpdate: url,
            itemType: 'SellItem',
            payload: {
                id: 0,
                invoiceCode: '',
                shiftId: 0,
                cardId: 0,
                cardCode: '',
                cardName: '',
                total: 0,
                totalPayment: 0,
                note: '',
                status: null,
                itemDetail: [],
                address: {},
                paymentMethod: [],
                nationality: '',
                dateOfBirth: null,
                citizenId: '',
                phone: '',
                typeDoc: '',
                country: '',
                cityName: ''
            },
            type: 'HOA_DON_VTS'
        };
    }

    getPurchase(index) {
        return {
            id: index,
            name: 'Mua hàng',
            Products: [],
            Customer: '',
            urlAdd: 'APInvoice/add',
            urlUpdate: 'APInvoice',
            addAndPayMent: '',
            status: 'I',
            nameUrl: 'APInvoice',
            itemType: 'BuyItem',
            payload: {
                id: 0,
                invoiceCode: '',
                cardId: 0,
                cardCode: '',
                shiftId: 0,
                // Quầy lập chứng từ — người dùng chốt trên màn hình, backend không tự đoán
                // (xem helper/counterPicker.js).
                counterId: null,
                cardName: '',
                total: 0,
                totalPayment: 0,
                note: '',
                status: null,
                itemDetail: [],
                address: {},
                paymentMethod: [],
                nationality: '',
                dateOfBirth: null,
                citizenId: '',
                phone: '',
                typeDoc: '',
                country: '',
                cityName: ''
            },
            type: 'MUA_HANG'
        };
    }
    getInvoiceJewelry(index) {
        const url = 'ARJewerly';
        return {
            id: index,
            name: 'Hóa đơn',
            Products: [],
            Customer: '',
            status: 'I',
            nameUrl: url,
            urlAdd: url + '/add',
            addAndPayMent: '',
            urlUpdate: url,
            itemType: 'SellItem',
            payload: {
                id: 0,
                invoiceCode: '',
                shiftId: 0,
                cardId: 0,
                cardCode: '',
                cardName: '',
                total: 0,
                totalPayment: 0,
                note: '',
                status: null,
                itemDetail: [],
                address: {},
                paymentMethod: [],
                nationality: '',
                dateOfBirth: null,
                citizenId: '',
                phone: '',
                typeDoc: '',
                country: '',
                cityName: ''
            },
            type: 'HOA_DON_VTS'
        };
    }
    getExchangeJewery(index) {
        return {
            id: index,
            name: 'Đổi trả hàng',
            Products: [],
            Customer: '',
            Rules: [],
            urlAdd: 'GoldJewelryExchange/add',
            urlUpdate: 'GoldJewelryExchange',
            addAndPayMent: '',
            status: 'I',
            nameUrl: 'GoldJewelryExchange',
            itemType: 'SellItem',
            payload: {
                id: 0,
                invoiceCode: '',
                cardId: 0,
                cardCode: '',
                shiftId: 0,
                cardName: '',
                total: 0,
                totalPayment: 0,
                note: '',
                status: null,
                itemDetail: [],
                address: {},
                paymentMethod: [],
                nationality: '',
                dateOfBirth: null,
                citizenId: '',
                phone: '',
                typeDoc: '',
                country: '',
                cityName: ''
            },
            type: 'DOI_TRA_HANG_VTS'
        };
    }

    getWarranteeJewery(index) {
        return {
            id: index,
            name: 'Bảo hành',
            Products: [],
            Customer: '',
            Rules: [],
            urlAdd: 'Warranty/add',
            urlUpdate: 'Warranty',
            addAndPayMent: '',
            nameUrl: 'Warranty',
            payload: {
                id: 0,
                invoiceCode: '',
                cardId: 0,
                cardCode: '',
                shiftId: 0,
                cardName: '',
                total: 0,
                totalPayment: 0,
                note: '',
                status: null,
                refId: null,
                refInvoiceCode: '',
                itemDetail: [],
                address: {},
                paymentMethod: [],
                nationality: '',
                dateOfBirth: null,
                citizenId: '',
                phone: '',
                typeDoc: '',
                country: '',
                cityName: ''
            },
            type: 'BAO_HANH'
        };
    }

    getPurchaseJewery(index) {
        return {
            id: index,
            name: 'Mua hàng',
            Products: [],
            Customer: '',
            Rules: [],
            urlAdd: 'APGoldJewelry/add',
            urlUpdate: 'APGoldJewelry',
            addAndPayMent: '',
            status: 'I',
            nameUrl: 'APGoldJewelry',
            itemType: 'BuyItem',
            payload: {
                id: 0,
                invoiceCode: '',
                cardId: 0,
                cardCode: '',
                shiftId: 0,
                cardName: '',
                total: 0,
                totalPayment: 0,
                note: '',
                terms: '1',
                status: null,
                itemDetail: [],
                address: {},
                paymentMethod: [],
                nationality: '',
                dateOfBirth: null,
                citizenId: '',
                phone: '',
                typeDoc: '',
                country: '',
                cityName: ''
            },
            type: 'MUA_HANG_VTS'
        };
    }

    getExchange(index) {
        return {
            id: index,
            name: 'Đổi hàng',
            Products: [],
            Customer: '',
            urlAdd: 'ReturnExchange/add',
            urlUpdate: 'ReturnExchange',
            addAndPayMent: '',
            status: 'I',
            nameUrl: 'ReturnExchange',
            itemType: 'BuyItem',
            payload: {
                id: 0,
                invoiceCode: '',
                cardId: 0,
                cardCode: '',
                cardName: '',
                shiftId: 0,
                total: 0,
                totalPayment: 0,
                note: '',
                status: null,
                itemDetail: [],
                address: {},
                paymentMethod: [],
                nationality: '',
                dateOfBirth: null,
                citizenId: '',
                phone: '',
                typeDoc: '',
                country: '',
                cityName: ''
            },
            type: 'DOI_HANG'
        };
    }

    getOrder(index) {
        return {
            id: index,
            name: 'Đặt hàng',
            Products: [],
            Customer: '',
            urlAdd: 'ARDpmInvoice/add',
            urlUpdate: 'ARDpmInvoice',
            addAndPayMent: '',
            status: 'I',
            nameUrl: 'ARDpmInvoice',
            itemType: 'BuyItem',
            payload: {
                id: 0,
                invoiceCode: '',
                cardId: 0,
                cardCode: '',
                cardName: '',
                shiftId: 0,
                // Quầy lập chứng từ — người dùng chốt trên màn hình, backend không tự đoán
                // (xem helper/counterPicker.js).
                counterId: null,
                total: 0,
                totalPayment: 0,
                note: '',
                status: null,
                paidPercent: 0,
                paidDpm: 0,
                depositAmount: 0,
                itemDetail: [],
                address: {},
                paymentMethod: [],
                nationality: '',
                dateOfBirth: null,
                citizenId: '',
                phone: '',
                typeDoc: '',
                country: '',
                cityName: ''
            },
            type: 'DAT_HANG'
        };
    }

    getOrderJewelry(index) {
        return {
            id: index,
            name: 'Đặt hàng',
            Products: [],
            Customer: '',
            urlAdd: 'ARJDpmGoldJewelry/add',
            urlUpdate: 'ARJDpmGoldJewelry',
            addAndPayMent: '',
            status: 'I',
            nameUrl: 'ARJDpmGoldJewelry',
            itemType: 'BuyItem',
            payload: {
                id: 0,
                invoiceCode: '',
                cardId: 0,
                cardCode: '',
                cardName: '',
                issueDate: new Date(),
                shiftId: 0,
                // Quầy lập chứng từ — người dùng chốt trên màn hình, backend không tự đoán
                // (xem helper/counterPicker.js).
                counterId: null,
                totalPromotionValue: 0,
                distcountAmountVoucher: 0,
                totalCardRankValue: 0,
                totalOriginalPrice: 0,
                temporaryAmount: 0,
                priceLeft: 0,
                total: 0,
                totalPayment: 0,
                note: '',
                status: null,
                paidPercent: 0,
                paidDpm: 0,
                itemDetail: [],
                address: {},
                paymentMethod: [],
                nationality: '',
                dateOfBirth: null,
                citizenId: '',
                phone: '',
                typeDoc: '',
                country: '',
                cityName: ''
            },
            type: 'DAT_HANG_VTS'
        };
    }
    // Set Product

    setProductInvoice(item, priecGold) {
        item.payload.itemDetail = item.Products.map((e) => ({
            id: 0,
            fatherId: 0,
            priceCodeTableId: item.priceCodeTableId,
            itemId: e.id,
            itemCode: e.itemCode,
            itemName: e.itemName,
            quantity: e.quantity,
            weightGold: e?.netGoldWeight?.weight || 0,
            price: e.price || this.setPriceList(priecGold, e, 'sellPrice'),
            lineTotal: e.lineTotal,
            ugpEntry: e?.ougp?.id || '',
            ougp: e?.ougp,
            note: e.note,
            goldContentId: e?.goldContent?.id || null,
            goldPriceListId: priecGold.id,
            // itemDetail bị dựng lại mỗi lần SET_PRODUCT chạy (thêm/xoá/đổi số lượng).
            // Không mang nfcUids theo thì tag đã quét ở các dòng trước biến mất.
            nfcUids: e.nfcUids || []
        }));
        item.payload.itemDetail.forEach((e) => {
            const weightGold = e.weightGold || 1;
            item.payload.total += Math.round(weightGold * e.price * e.quantity);
        });

        if (item.payload.paymentMethod?.length < 2) {
            item.payload.paymentMethod = [{ id: 0, fatherId: 0, paymentMethodCode: 'Cash', paymentMethodName: 'Tiền mặt', amount: item.payload.total || 0 }];
        }
    }

    setProductPurchase(item, priecGold) {
        item.payload.itemDetail = item.Products.map((e) => ({
            id: 0,
            fatherId: 0,
            itemId: e.id,
            priceCodeTableId: item.priceCodeTableId,
            itemCode: e.itemCode,
            itemName: e.itemName,
            quantity: e.quantity,
            weightGold: e?.netGoldWeight?.weight || 0,
            price: e.price || this.setPriceList(priecGold, e, 'buyPrice'),
            lineTotal: e.lineTotal,
            ugpEntry: e?.ougp?.id || '',
            ougp: e?.ougp,
            note: e.note,
            manBtchNum: e.manBtchNum,
            goldPriceListId: priecGold.id,
            goldRate: e.goldRate || e?.goldContent?.rate,
            editContentGold: ['THO'].includes(e?.itemGroup1?.itmsGrpCode) || ['VRTLHOI'].includes(e.itemCode),
            rate: e?.goldContent?.rate || 0,
            toRate: e?.goldContent?.toRate || 0,
            // Xem chú thích ở setProductInvoice.
            nfcUids: e.nfcUids || []
        }));

        item.payload.itemDetail.forEach((e) => {
            const weightGold = e.weightGold || 1;
            item.payload.total += Math.round(weightGold * e.price * e.quantity);
        });
        if (item.payload.paymentMethod?.length < 2) {
            item.payload.paymentMethod = [{ id: 0, fatherId: 0, paymentMethodCode: 'Cash', paymentMethodName: 'Tiền mặt', amount: item.payload.total || 0 }];
        }
    }

    setProductExchange(item, priecGold) {
        item.payload.itemDetail = item.Products.map((e) => ({
            id: 0,
            fatherId: 0,
            itemId: e.id,
            itemCode: e.itemCode,
            itemName: e.itemName,
            quantity: e.quantity,
            weightGold: e?.netGoldWeight?.weight || 0,
            price: e.price || this.setPriceList(priecGold, e, 'buyPrice'),
            lineTotal: e.lineTotal || 0,
            ugpEntry: e?.ougp?.id || '',
            ougp: e?.ougp,
            note: e.note,
            actionType: e.actionType,
            goldContent: e.goldContent,
            weightGold: e.netGoldWeight?.weight || 0,
            goldPriceListId: priecGold.id,
            goldRate: e.goldRate || e?.goldContent?.rate,
            editContentGold: ['THO'].includes(e?.itemGroup1?.itmsGrpCode) || ['VRTLHOI'].includes(e.itemCode),
            rate: e?.goldContent?.rate || 0,
            toRate: e?.goldContent?.toRate || 0,
            // Xem chú thích ở setProductInvoice.
            nfcUids: e.nfcUids || []
        }));
        item.payload.itemDetail.forEach((e) => {
            const weightGold = e.weightGold || 1;
            item.payload.total += Math.round(weightGold * e.price * e.quantity);
        });
        if (item.payload.paymentMethod?.length < 2) {
            item.payload.paymentMethod = [{ id: 0, fatherId: 0, paymentMethodCode: 'Cash', paymentMethodName: 'Tiền mặt', amount: item.payload.total || 0 }];
        }
    }

    setProductWarantyJewelry(item, priceGold) {
        item.payload.itemDetail = item.Products.map((e) => ({
            id: 0,
            fatherId: 0,
            index: e.index,
            itemId: e.id,
            itemCode: e.itemCode,
            itemName: e.itemName,
            quantity: e.quantity,
            weightGold: e?.netGoldWeight?.weight || 0,
            price: e.price || this.setPriceList(priceGold, e, 'buyPrice'),
            lineTotal: e.lineTotal || 0,
            ugpEntry: e?.ougp?.id || '',
            ougp: e?.ougp,
            serviceFee: 'Miễn phí',
            note: e.note,
            productWeightBefore: 0,
            goldContent: 0,
            productWeightAfter: 0,
            // Đổ sẵn giá mua vào để preview hao theo công thức ngay lúc tạo phiếu;
            // backend sẽ ghi đè bằng giá THO mua vào thực tế ở bước thanh toán.
            marketGoldPrice: e.price || this.setPriceList(priceGold, e, 'buyPrice'),
            vatCode: null, //Màu sắc
            warrantyExpiryDate: new Date(),
            actionType: e.actionType,
            serialBatchNumber: '',
            weightGold: e.netGoldWeight?.weight || 0,
            goldPriceListId: priceGold.id,
            goldRate: e.goldRate || e?.goldContent?.rate,
            editContentGold: ['THO'].includes(e?.itemGroup1?.itmsGrpCode) || ['VRTLHOI'].includes(e.itemCode),
            rate: e?.goldContent?.rate || 0,
            toRate: e?.goldContent?.toRate || 0,
            listService: []
        }));
    }

    setProductOrder(item, priecGold) {
        item.payload.itemDetail = item.Products.map((e) => ({
            id: e.itemId ? e.id || 0 : 0,
            fatherId: e.fatherId || 0,
            itemId: e.id,
            itemCode: e.itemCode,
            itemName: e.itemName,
            quantity: e.quantity,
            weightGold: e?.netGoldWeight?.weight || 0,
            price: e.price || this.setPriceList(priecGold, e, 'sellPrice'),
            serial: e.serial,
            lineTotal: e.lineTotal,
            ugpEntry: e?.ougp?.id || '',
            ougp: e?.ougp,
            note: e.note,
            goldContentId: e?.goldContent?.id || null,
            goldPriceListId: priecGold.id,
            // Xem chú thích ở setProductInvoice.
            nfcUids: e.nfcUids || []
        }));

        item.payload.itemDetail.forEach((e) => {
            const weightGold = e.weightGold || 1;
            item.payload.total += Math.round(weightGold * e.price * e.quantity);
        });
        item.payload.paymentMethod = [{ id: 0, fatherId: 0, paymentMethodCode: 'Cash', paymentMethodName: 'Tiền mặt', amount: item.payload.total - item.payload.paidDpm || 0 }];
    }

    setPriceList(data, item, filed) {
        const user = JSON.parse(localStorage.getItem('user'))?.appUser || null;
        if (user.bizSectors[0]?.itmsGrpCode == 'VTS') return 0;

        const price = data.goldPriceListLine.find((e) => e.goldCodeName == item.itemGroup1?.itmsGrpCode);
        if (price != undefined) price[filed];
        return price != undefined ? price[filed] : 0;
    }

    //VTS
    getGuarantee = (index) => {
        return {
            id: index,
            name: 'Bảo hành',
            Products: [],
            Customer: '',
            urlAdd: 'Warranty/add',
            urlUpdate: 'Warranty',
            addAndPayMent: '',
            status: 'I',
            nameUrl: 'Warranty',
            itemType: 'BuyItem',
            payload: {
                id: 0,
                invoiceCode: '',
                cardId: 0,
                cardCode: '',
                cardName: '',
                issueDate: new Date(),
                shiftId: 0,
                isSpecialWarranty: false,
                totalPromotionValue: 0,
                distcountAmountVoucher: 0,
                totalCardRankValue: 0,
                totalOriginalPrice: 0,
                temporaryAmount: 0,
                priceLeft: 0,
                total: 0,
                totalPayment: 0,
                note: '',
                status: null,
                refId: null,
                refInvoiceCode: '',
                paidPercent: 0,
                paidDpm: 0,
                itemDetail: [],
                address: {},
                paymentMethod: []
            },
            type: 'BAO_HANH'
        };
    };

    //KIEM DINH
    getAssessment = (index) => {
        return {
            id: index,
            name: 'Dịch vụ',
            Products: [],
            Customer: '',
            urlAdd: 'Inspection/add',
            urlUpdate: 'Inspection',
            addAndPayMent: '',
            status: 'I',
            nameUrl: 'Inspection',
            itemType: 'BuyItem',
            payload: {
                id: 0,
                invoiceCode: '',
                cardId: 0,
                cardCode: '',
                cardName: '',
                issueDate: new Date(),
                shiftId: 0,
                isSpecialWarranty: true,
                totalPromotionValue: 0,
                distcountAmountVoucher: 0,
                totalCardRankValue: 0,
                totalOriginalPrice: 0,
                temporaryAmount: 0,
                priceLeft: 0,
                total: 0,
                totalPayment: 0,
                note: '',
                status: null,
                paidPercent: 0,
                paidDpm: 0,
                itemDetail: [],
                address: {},
                paymentMethod: []
            },
            type: 'KIEM_DINH'
        };
    }
    //3: Giá niêm yết / Giá mã giá thời điểm (field `price` của dòng hàng)
    getPrice = (e, priecGold, priceCodes, priceCodeTable) => {
        // Nguồn serial: nếu là mảng dùng phần tử đầu, ngược lại dùng chính object serial.
        // Fallback {} để không throw khi serial null/undefined (hàng chưa gắn serial).
        const serialData = (Array.isArray(e?.serial) ? e.serial[0] : e?.serial) || {};
        const {
            priceManagement, //Quản lý giá bán
            priceCode, //Mã giá
            goldContent //Hàm lượng vàng
        } = serialData;
        // FIX: đọc tiền công gốc & hệ số bán đúng cấp serialData.
        // (Trước đây đọc e.serial.labourAmount / e.serial.salesCoefficient — khi serial là mảng
        //  thì các field này nằm ở e.serial[0], nên luôn undefined -> fallback 0 -> giá VTPT = 0.)
        const labourAmount = e?.makingCharge || serialData.labourAmount || 0;
        const salesCoefficient = e?.coefficient || serialData.salesCoefficient || 0;

        let result = 0;
        let reason = '';

        switch (priceManagement) {
            case 'Mã giá': {
                if (!priceCode) {
                    reason = "priceManagement='Mã giá' nhưng serial.priceCode rỗng";
                    break;
                }
                const res = this.setPriceCodeJewelry(priceCodes, e, 'type', priceCode);
                if (res?.type == 'VTPT') {
                    //(Hàm lượng * Giá mã giá thời điểm + Tiền công gốc) * Hệ số bán
                    const gc = Number(goldContent);
                    if (!Number.isFinite(gc)) {
                        reason = `VTPT nhưng goldContent không hợp lệ (=${goldContent})`;
                        break;
                    }
                    const goldBase = this.setPriceListJewelryById(priecGold, e, 'sellPrice', res.materialId);
                    result = ((gc / 100) * goldBase + labourAmount) * salesCoefficient;
                    if (!result) reason = `VTPT ra 0 (goldBase=${goldBase}, labourAmount=${labourAmount}, salesCoefficient=${salesCoefficient}, materialId=${res.materialId})`;
                } else if (res?.type == 'VNN' || res?.type == 'BAC') {
                    result = this.setPriceCodeTable(priceCodeTable, e, 'sellingPrice', res.code, res.type);
                    if (!result) reason = `${res.type}: setPriceCodeTable không khớp bảng/line/branch-scope (code=${res.code})`;
                } else {
                    reason = res ? `priceCode='${priceCode}' khớp nhưng type lạ (=${res.type})` : `priceCode='${priceCode}' không có trong priceCodes (master chưa load / đã đổi sau khi cache)`;
                }
                break;
            }
            case 'Niêm yết giá': {
                // Hàng niêm yết không có "giá mã giá thời điểm" — đơn giá của dòng chính là
                // giá niêm yết đã gắn sẵn trên serial (priceAfterDist). Trả về giá này để field
                // `price` luôn đúng nghĩa cột "Giá niêm yết/Giá mã giá" thay vì lưu 0.
                result = Number(serialData.priceAfterDist) || 0;
                if (!result) reason = `Niêm yết giá nhưng serial.priceAfterDist rỗng/0 (=${serialData.priceAfterDist})`;
                break;
            }
            case 'Giá mã giá':
            case 'Giá bán theo Bảng giá':
                reason = `priceManagement='${priceManagement}' không tính giá thời điểm (đúng thiết kế)`;
                break;
            case 'MNVT9999':
                result = this.setPriceListJewelry(priecGold, e, 'sellPrice', 'MNVT9999');
                break;
            case 'MNVT999':
                result = this.setPriceListJewelry(priecGold, e, 'sellPrice', 'MNVT999');
                break;
            case 'Giá bán theo giá nguyên liệu':
                result = this.setPriceListJewelry(priecGold, e, 'sellPrice', goldContent == 99.9 ? 'MNVT999' : 'MNVT9999');
                break;
            case 'Tem mác':
                result = this.setPriceListJewelry(priecGold, e, 'sellPrice', 'MNVT9999');
                break;
            default:
                reason = `priceManagement không hợp lệ/không nhận diện (=${JSON.stringify(priceManagement)})`;
                break;
        }

        // Chẩn đoán: vì sao cột "Giá niêm yết/Giá mã giá" hiển thị "Không có" (price falsy)
        if (!result) {
            if (!reason) reason = `giá tra ra 0 (priceManagement='${priceManagement}') — kiểm tra feed giá vàng / sellPrice`;
            console.warn('[getPrice] "Không có" →', reason, {
                itemCode: e?.itemCode,
                itemName: e?.itemName,
                priceManagement,
                priceCode,
                goldContent,
                labourAmount,
                salesCoefficient,
                hasSerial: !!e?.serial,
                serialIsArray: Array.isArray(e?.serial),
                result
            });
            return 0; // chuẩn hoá NaN/undefined -> 0 để không lan ra lineTotal
        }

        return result;
    };

    //3: Tính tổng giá trị dựa trên loại quản lý giá bán
    getLineTotal = async (e, priecGold, priceCodes, priceCodeTable) => {
        const priceManagement = e.serial?.priceManagement || e.priceListType?.name || '';

        if (priceManagement === 'Giá bán theo Bảng giá') {
            try {
                const lines = await this.getActiveSalesPriceLines();
                const matched = lines.find((line) => line.itemCode === e.itemCode);
                return matched?.unitPrice || 0;
            } catch (error) {
                console.log('Error fetching SalesPriceList:', error);
                return 0;
            }
        }
        await this.getActiveBACPriceLines()
        if (!e?.serial) return 0;

        const {
            totalWeight,
            priceAfterDist,
            weightGold,
            goldContent,
            goldCoefficient,
            originalWage,
            sizeDiamond,
            stoneCoefficient,
            labourAmount,
            workCoefficient,
            salesCoefficient
        } = e.serial;
        const rules = e.rules || {};

        switch (priceManagement) {
            // Công thức mới: Giá bán = Trọng lượng SP * (Hàm lượng * Giá mã giá + Tiền công) * Hệ số
            case 'Mã giá':
                const priceCode = this.getPrice(e, priecGold, priceCodes, priceCodeTable) || 0;
                if (rules.priceList == 'VTPT') {
                    return totalWeight * priceCode || 0;
                } else if (rules.priceList == 'VTNN') {
                    return totalWeight * priceCode || 0;
                } else if (rules.priceList == 'BAC') {
                    const bacLines = await this.getActiveBACPriceLines();
                    const matched = bacLines.find((line) => line.priceCode === e.serial?.priceCode);
                    const priceBAC = matched?.sellingPrice || 0;
                    return totalWeight * priceBAC || 0;
                }
                return 0;
            // Trường hợp Niêm yết giá: Lấy trực tiếp từ giá niêm yết
            case 'Niêm yết giá':
                return priceAfterDist;
            //Trường hợp Giá bán theo giá nguyên liệu
            case 'Giá bán theo giá nguyên liệu':
                if (goldContent == 99.99) {
                    const price = priecGold?.goldPriceListLine?.find((line) => line.goldCodeId == rules.goldCodeTable99_99)?.sellPrice || 0;
                    return weightGold * price + originalWage * stoneCoefficient + labourAmount * workCoefficient || 0;
                } else if (goldContent == 99.9) {
                    const price = priecGold?.goldPriceListLine?.find((line) => line.goldCodeId == rules.goldCodeTable99_9)?.sellPrice || 0;
                    return weightGold * price + originalWage * stoneCoefficient + labourAmount * workCoefficient || 0;
                }
                return 0;

            default:
                return 0;
        }
    };

    /** Lấy salesPriceListLine từ bảng giá bán đang hoạt động, cache 60s */
    async getActiveSalesPriceLines() {
        const CACHE_TTL = 60_000;
        if (this._salesPriceCache && Date.now() - this._salesPriceCacheTime < CACHE_TTL) {
            return this._salesPriceCache;
        }
        const res = await API.get('SalesPriceList?Filter=(isActive=true)');
        const list = Array.isArray(res.data?.data) ? res.data.data : Array.isArray(res.data) ? res.data : [];
        const activeItem = list.find((item) => item.isActive === true);
        if (!activeItem) {
            this._salesPriceCache = [];
            this._salesPriceCacheTime = Date.now();
            return [];
        }
        const detail = await API.get(`SalesPriceList/${activeItem.id}`);
        const lines = detail.data?.salesPriceListLine || [];
        this._salesPriceCache = lines;
        this._salesPriceCacheTime = Date.now();
        return lines;
    }
    _bacPriceCache = null;
    _bacPriceCacheTime = 0;
    async getActiveBACPriceLines() {
        const CACHE_TTL = 60_000;
        if (this._bacPriceCache && Date.now() - this._bacPriceCacheTime < CACHE_TTL) {
            return this._bacPriceCache;
        }
        const res = await API.get('PriceCodeTable/getAll?Filter=isActive=true,priceCodeTableType=BAC');
        const items = res.data?.items || [];
        const lines = items[0]?.priceCodeTableLines || [];
        this._bacPriceCache = lines;
        this._bacPriceCacheTime = Date.now();
        return lines;
    }
    formatPrice = (price) => {
        return price.toLocaleString('en-US', { style: 'currency', currency: 'VND' });
    };

    /**
     * Xử lý chi tiết sản phẩm trong hóa đơn trang sức
     */
    async setProductInvoiceJewelry(item, priecGold, priceCodes, priceCodeTable) {
        try {
            const itemTypeIn = item.payload.itemDetail.filter((e) => e.actionType != 'OUT');
            let product = item.Products.filter((e) => !item.payload.itemDetail.find((i) => i.serialBatchNumber === e?.serial?.serialNumber && i.manBtchNum !== 'Y'));
            product = product.filter((e) => !item.payload.itemDetail.find((i) => i.itemId === e.id && !i.serialBatchNumber));

            item.payload.itemDetail.push(
                ...(await Promise.all(
                    product.map(async (product) => {
                        let totalAmount = 0;
                        let sellingStoneCost = 0;
                        let sellingLaborCost = 0;
                        let lineTotal = 0;
                        let promotionValue = 0;
                        let priceAfterDiscount = 0;
                        let price = 0;
                        const isPriceByTable = product.priceListType?.name === 'Giá bán theo Bảng giá';
                        if (product.serial) {
                            lineTotal = await this.getLineTotal(product, priecGold, priceCodes, priceCodeTable);
                            price = this.getPrice(product, priecGold, priceCodes, priceCodeTable);
                            delete product.serial.id;
                            sellingStoneCost = (product.serial.originalWage || 0) * (product.serial.stoneCoefficient || 0) || 0;
                            sellingLaborCost = (product.serial.labourAmount || 0) * (product.serial.workCoefficient || 0) || 0;
                        } else if (isPriceByTable) {
                            lineTotal = await this.getLineTotal(product, priecGold, priceCodes, priceCodeTable);
                        } else {
                            // Hàng không serial (vd vàng nguyên liệu/miếng quản lý theo lô) bán theo "Niêm yết giá":
                            // getPrice/getLineTotal đều cần serial nên bị bỏ qua -> tra giá niêm yết trực tiếp từ feed giá vàng.
                            // LOG CHẨN ĐOÁN (tạm) để map đúng mã vàng -> sẽ thay bằng công thức sau khi xác nhận dữ liệu.
                            console.warn('[setProductInvoiceJewelry] hàng KHÔNG serial — giá trị field ứng viên (copy chuỗi JSON bên dưới)');
                            console.warn('[product candidates JSON]', JSON.stringify({
                                itemCode: product?.itemCode,
                                itemName: product?.itemName,
                                priceList: product?.priceList,
                                itemPriceCode: product?.itemPriceCode,
                                itM1s: product?.itM1s,
                                ougp: product?.ougp,
                                coefficient: product?.coefficient,
                                makingCharge: product?.makingCharge,
                                priceListType: product?.priceListType
                            }));
                        }

                        const detail = this.createDetailObject(product, lineTotal, price, priecGold);
                        // Tính toán các giá trị chiết khấu và tổng tiền
                        promotionValue = this.calculatePromotionValue(detail, lineTotal);
                        //Tính giá sau chiết khấu
                        priceAfterDiscount = this.calculatePriceAfterDiscount(lineTotal, detail, promotionValue);
                        //Tính tổng tiền
                        totalAmount = this.calculateTotalAmount(detail.quantity, priceAfterDiscount);

                        return {
                            ...detail,
                            actionType: 'OUT',
                            sellingStoneCost,
                            sellingLaborCost,
                            totalPromotionValue: promotionValue,
                            unitPriceAfterTransfer: priceAfterDiscount,
                            totalAmount,
                            lineTotal: totalAmount,
                            promotions: []
                        };
                    })
                ).then((results) => results.filter(Boolean)))
            );
            itemTypeIn.forEach((e) => {
                item.payload.itemDetail.push(e);
            });
            // Cập nhật tổng tiền hóa đơn
            this.updateInvoiceTotal(item);
            this.initializePaymentMethod(item);
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    /**
     * Tạo đối tượng chi tiết sản phẩm
     */
    createDetailObject(product, lineTotal, price, priecGold) {
        return {
            id: 0,
            fatherId: 0,
            itemId: product.id,
            itemCode: product.itemCode,
            itemName: product.itemName,
            lineTotal,
            quantity: product.quantity || 1,
            weightGold: product?.netGoldWeight?.weight || 0,
            price,
            ugpEntry: product?.ougp?.id || '',
            priceManagement: product?.serial?.priceManagement || '',
            priceCode: product?.serial?.priceCode || '',
            cardRankRate: 0,
            productRate: 0,
            stonePriceRate: 0,
            stonePrice: 0,
            laborCostRate: 0,
            reweighValueDifference: 0,
            voucher: 0,
            diamondSize: product?.serial?.sizeDiamond || 0,
            actionType: product.actionType || '',
            certificationNumber: product?.serial?.domesticCertificationInfo || '',
            ougp: product?.ougp,
            serialObj: product?.serial || '',
            serialBatchNumber: product?.serial?.length ? product?.serial[0]?.serialNumber : product?.serial?.serialNumber || '',
            serial: product?.serial ? [product.serial] : [],
            taxItem: product.taxItem,
            taxRate: product.taxRate ?? product.taxItem?.taxRate,
            note: product.note || '',
            goldContentId: product?.goldContent?.id || null,
            goldPriceListId: priecGold.id || 0,
            priceListType: product?.priceListType || '',
            totalCardRankValue: 0,
            totalPromotionValue: 0,
            unitPriceAfterTransfer: 0,
            totalAmount: 0,
            totalReweighWeight: product?.serial?.totalWeight || 0,
            priceAndTransactionDateTime: this.formatPriceAndDateTime(priecGold),
            pricePurchase: this.getPriceGoldNHANVRTL(priecGold),
            sellPrice: this.getPriceGoldNHANVRTL(priecGold, 'sellPrice')
        };
    }

    /**
     * Tính tổng giá trị chiết khấu khuyến mãi
     */
    calculatePromotionValue(detail, lineTotal) {
        return (
            lineTotal * detail.productRate +
            (detail.serialObj.originalWage || 0) * (detail.serialObj.stoneCoefficient || 0) * detail.stonePriceRate +
            (detail.serialObj.labourAmount || 0) * (detail.serialObj.workCoefficient || 0) * detail.laborCostRate
        );
    }

    /**
     * Tính giá sau chiết khấu
     */
    calculatePriceAfterDiscount(lineTotal, detail, promotionValue) {
        return lineTotal - detail.totalCardRankValue - promotionValue + detail.reweighValueDifference;
    }

    /**
     * Tính tổng tiền
     */
    calculateTotalAmount(quantity, priceAfterDiscount) {
        return quantity * priceAfterDiscount;
    }

    /**
     * Cập nhật tổng tiền hóa đơn
     */
    updateInvoiceTotal(item) {
        item.payload.total = item.payload.itemDetail
            .filter((e) => e.serialBatchNumber)
            .reduce((sum, detail) => {
                return sum + Math.round(detail.totalAmount || 0);
            }, 0);
    }

    /**
     * Khởi tạo phương thức thanh toán mặc định
     */
    initializePaymentMethod(item) {
        if (item.payload.paymentMethod?.length < 1) {
            item.payload.paymentMethod.push({
                id: 0,
                fatherId: 0,
                paymentMethodCode: 'Cash',
                paymentMethodName: 'Tiền mặt',
                amount: item.payload.total || 0
            });
        }
    }

    /**
     * Cập nhật sản phẩm trong hóa đơn trang sức - chỉ cập nhật giá theo bảng mã giá
     * Giữ nguyên các giá trị đã thiết lập trước đó
     */
    async updateProductInvoiceJewelry(item, priecGold, priceCodes, priceCodeTable) {
        try {
            // Kiểm tra dữ liệu đầu vào
            if (!item.payload || !item.payload.itemDetail || !Array.isArray(item.payload.itemDetail)) {
                console.warn('itemDetail không tồn tại hoặc không phải mảng:', item.payload);
                return;
            }
            // Lấy các item có actionType khác 'OUT' để giữ nguyên
            const itemTypeIn = item.payload.itemDetail.filter((e) => e.actionType != 'OUT');

            // Cập nhật các sản phẩm đã có serial
            const updatedItems = await Promise.all(
                item.payload.itemDetail
                    .filter((detail) => detail.actionType == 'OUT' && detail.serialBatchNumber)
                    .map(async (detail) => {
                        // Tạo đối tượng product từ detail để tính toán lại
                        const serialData = detail.serial?.length > 0 ? detail.serial[0] : detail.serial;
                        const product = {
                            id: detail.itemId,
                            itemCode: detail.itemCode,
                            itemName: detail.itemName,
                            serial: serialData,
                            ougp: detail.ougp,
                            rules: detail.rules || {},
                            actionType: detail.actionType,
                            netGoldWeight: { weight: detail.weightGold || serialData?.weightGold || 0 },
                            goldContent: detail.goldContent || {
                                id: detail.goldContentId,
                                rate: serialData?.goldContent || 0
                            },
                            note: detail.note || '',
                            priceListType: detail.priceListType || ''
                        };
                        // Tính toán lại giá trị dựa trên công thức mới
                        const lineTotal = await this.getLineTotal(product, priecGold, priceCodes, priceCodeTable);
                        const price = this.getPrice(product, priecGold, priceCodes, priceCodeTable);

                        // Giữ nguyên các giá trị chiết khấu đã thiết lập
                        const existingPromotionValue = detail.totalPromotionValue || 0;
                        const existingReweighDifference = detail.reweighValueDifference || 0;
                        const existingVoucher = detail.voucher || 0;

                        // Tính lại giá sau chiết khấu với các giá trị chiết khấu đã có
                        const priceAfterDiscount = lineTotal - existingPromotionValue + existingReweighDifference;
                        const totalAmount = detail.quantity * (priceAfterDiscount - existingVoucher);

                        // Cập nhật chỉ các giá trị liên quan đến giá và công thức
                        return {
                            ...detail, // Giữ nguyên tất cả giá trị cũ
                            lineTotal, // Cập nhật giá trị tính toán mới
                            price, // Cập nhật giá mới
                            unitPriceAfterTransfer: priceAfterDiscount, // Cập nhật giá sau chiết khấu
                            totalAmount, // Cập nhật thành tiền
                            // Cập nhật thông tin giá và thời gian
                            priceAndTransactionDateTime: this.formatPriceAndDateTime(priecGold),
                            pricePurchase: this.getPriceGoldNHANVRTL(priecGold),
                            sellPrice: this.getPriceGoldNHANVRTL(priecGold, 'sellPrice'),
                            goldPriceListId: priecGold.id || 0
                        };
                    })
            );

            // Thêm lại các item có actionType khác 'OUT'
            const allItems = [...updatedItems, ...itemTypeIn];
            item.payload.itemDetail = allItems;
        } catch (error) {
            console.log('Error updating product invoice jewelry:', error);
            throw error;
        }
    }

    /**
     * Format giá và thời gian
     */
    formatPriceAndDateTime(priecGold, type = 'sellPrice') {
        if (!priecGold || !priecGold.goldPriceListLine) return '';
        const price = priecGold.goldPriceListLine.find((line) => line.goldCodeName == 'MNVT9999')?.[type];
        if (!price || !priecGold.time) return '';
        return `${this.formatPrice(price)} - ${format(priecGold.time, 'dd/MM/yyyy HH:mm')}`;
    }

    getPriceGoldNHANVRTL(priecGold, type = 'buyPrice') {
        if (!priecGold || !priecGold.goldPriceListLine) return '';
        const price = priecGold.goldPriceListLine.find((line) => line.goldCodeName == 'MNVT9999')?.[type];
        if (!price) return 0;
        return price;
    }
    /**
     * Lấy giá từ bảng giá trang sức
     */
    setPriceListJewelry(data, item, field, type = null) {
        const user = JSON.parse(localStorage.getItem('user'))?.appUser;
        if (user?.bizSectors?.[0]?.itmsGrpCode === 'VTD') return 0;
        const price = data?.goldPriceListLine?.find((line) => line.goldCodeName === (type || item?.itemGroup1?.itmsGrpCode));
        return price ? price[field] : 0;
    }

    /**
     * Lấy giá từ bảng giá trang sức theo ID
     */
    setPriceListJewelryById(data, item, field, idPrice = null) {
        const price = data?.goldPriceListLine?.find((line) => line.goldCodeId == idPrice);
        return price ? price[field] : 0;
    }

    /**
     * Lấy mã giá trang sức
     */
    setPriceCodeJewelry(data, item, field, type = null) {
        const user = JSON.parse(localStorage.getItem('user'))?.appUser;
        if (user?.bizSectors?.[0]?.itmsGrpCode === 'VTD') return 0;
        return data?.find((price) => price.code == (type || item?.itemGroupId1));
    }

    //Xử lý Đổi trả hàng
    setRecipeInvoiceJewelry(itemDetail, goldPrices, priceCodes, priceCodeTable) {
        try {
            const itemOut = itemDetail.payload.itemDetail.filter((e) => e.actionType == 'OUT');
            itemDetail.payload.itemDetail = itemDetail.recipe.map((e) => {
                const item = e.itemDetail;
                const {
                    totalWeight, // Tổng trọng lượng
                    priceAfterDist, // Giá sau phân phối (giá niêm yết)
                    priceManagement, // Loại quản lý giá bán
                    weightGold, // Trọng lượng vàng
                    goldContent, // Hàm lượng vàng
                    goldCoefficient, // Hệ số vàng
                    originalWage, // Tiền đá gốc
                    priceCode,
                    stoneCoefficient, // Hệ số đá
                    serialNumber,
                    labourAmount, // Tiền công gốc
                    workCoefficient, // Hệ số công
                    salesCoefficient // Hệ số bán
                } = item.serial?.length ? item.serial[0] : item.serial;
                item.serial?.length ? (item.serial[0].id = 0) : (item.serial.id = 0);
                const line = e.purchasePriceRuleLine.find((line) => line.id);

                if (line.isApplied === true) {
                    window.alert('Serial: ' + serialNumber + ' áp dụng quy tắc đối với sản phẩm không còn nguyên vẹn, mẫu mã không thịnh hành!');
                    return false;
                }
                const price = this.getPrice(item, goldPrices, priceCodes, priceCodeTable);
                const priceStoreAfterCK = originalWage * stoneCoefficient * (1 - item.stonePriceRate / 100); //Giá đá sau CK
                let wage = 0;
                const getRateBuyChange = () => {
                    const purchasePriceRuleLine = e.purchasePriceRuleLine.find((line) => line.id);

                    // Tính tổng giá trị các biến unitPriceAfterTransfer trong itemOut
                    const totalUnitPriceAfterTransfer = itemOut.reduce((sum, curr) => sum + (curr.unitPriceAfterTransfer || 0), 0);
                    if (itemOut.length > 0) {
                        if (e.priceFormula == 'CK giá đá trên hóa đơn (2)') {
                            const serialOut = itemOut[0]?.serial[0] || {};
                            const priceStoreAfterCKOut = serialOut?.originalWage * serialOut?.stoneCoefficient * (1 - itemOut[0]?.stonePriceRate / 100); //Giá trị đá sau ck của out
                            if (priceStoreAfterCKOut >= priceStoreAfterCK) {
                                wage = line?.isLabour ? (labourAmount * workCoefficient * (1 - item.laborCostRate / 100)) / 2 : 0;
                                return purchasePriceRuleLine.exchangePercent || 0;
                            }
                        } else if (totalUnitPriceAfterTransfer >= item.unitPriceAfterTransfer) {
                            // Nếu phiếu bán có tổng giá trị lớn  hơn phiếu mua
                            wage = line?.isLabour ? (labourAmount * workCoefficient * (1 - item.laborCostRate / 100)) / 2 : 0;
                            return purchasePriceRuleLine.exchangePercent || 0;
                        }
                    }
                    return purchasePriceRuleLine.purchasePercent || 0;
                };
                //Tính tỉ lệ mua/đổi
                const rateBuyChange = getRateBuyChange() || 0;
                const getDiffPrice = () => {
                    //Chênh lệch giá vàng
                    if (e.isDiffPrice) {
                        const extractPrice = (priceString) => {
                            const match = priceString.match(/[\d,.]+/);
                            if (match) {
                                return parseFloat(match[0].replace(/\./g, '').replace(',', '.'));
                            }
                            return 0;
                        };

                        const price1 = extractPrice(item.priceAndTransactionDateTime);
                        const price2 = extractPrice(this.formatPriceAndDateTime(goldPrices));
                        return (price1 - price2) * ((goldContent || 0) / 100) * (weightGold || 0);
                    }
                    return 0;
                };
                const diffPrice = getDiffPrice();
                //Giá vàng theo mã giá CT = (Giá vàng thời điểm mua lại * hàm lượng vàng + tiền công) * hệ số bán
                // Không dùng item.sellPrice: đó là giá vàng lúc bán, đóng băng trên hoá đơn cũ.
                const materialId = this.setPriceCodeJewelry(priceCodes, item, 'type', priceCode)?.materialId;
                const goldPriceNow = this.setPriceListJewelryById(goldPrices, item, 'sellPrice', materialId);
                const priceByCode = (goldPriceNow * (goldContent / 100) + labourAmount) * salesCoefficient; //Giá vàng theo mã giá;
                const primaryGold = goldContent == 99.9 ? e.primaryGold_9 : goldContent == 99.99 ? e.primaryGold_99 : '';
                const parentGoldPriceNumber = goldPrices.goldPriceListLine.find((line) => line.goldCodeName == primaryGold)?.buyPrice || 0;
                const priceCodeTableVNN = this.setPriceCodeTable(priceCodeTable, null, 'sellingPrice', e.itemDetail.priceCode, 'VNN');
                const goldPriceCode = e.priceFormula == 'Tính theo mã giá VTNN (3.2)' ? priceCodeTableVNN : priceByCode;
                //Tính tỉ lệ CK toàn bộ SP
                let totalStoneAmount = 0;
                let totalGoldAmount = 0;
                // Voucher giảm % chỉ trừ ở công thức tính theo giá hóa đơn: (1) giá SP, (2) phần đá.
                // Công thức theo giá hiện tại (3.1, 3.2, 4) không liên quan voucher.
                const voucherPerUnit = (item.voucher || 0) / (item.quantity || 1);
                const invoicePriceAfterCK = (item.unitPriceAfterTransfer || 0) - voucherPerUnit;
                const voucherRate = item.totalAmount > 0 ? (item.voucher || 0) / item.totalAmount : 0; // voucher áp trên toàn sản phẩm
                const rateBuy = parseFloat((((item.lineTotal - item.totalAmount) / item.lineTotal) * 100).toFixed(2));
                const getPriceByRecipe = () => {
                    if (e.priceFormula == 'CK giá SP trên hóa đơn (1)') {
                        return invoicePriceAfterCK * (rateBuyChange / 100) + diffPrice;
                    } else if (e.priceFormula == 'CK giá đá trên hóa đơn (2)') {
                        totalStoneAmount = priceStoreAfterCK * (1 - voucherRate) * (rateBuyChange / 100);
                        //(Hàm lượng vàng x trọng lượng vàng x Giá MNVT9999)
                        totalGoldAmount = (goldContent / 100) * weightGold * parentGoldPriceNumber || 0;
                        return totalStoneAmount + totalGoldAmount;
                    } else if (e.priceFormula == 'Tính theo mã giá VTPT (3.1)') {
                        return priceByCode * totalWeight * (1 - rateBuy / 100 || 0) * (rateBuyChange / 100);
                    } else if (e.priceFormula == 'Tính theo mã giá VTNN (3.2)') {
                        //Giá mua/đổi = Giá vàng theo mã giá x Trọng lượng x (100% - % CK tại thời điểm bán) x Tỉ lệ mua/đổi
                        return priceCodeTableVNN * totalWeight * (1 - rateBuy / 100 || 0) * (rateBuyChange / 100);
                    } else if (e.priceFormula == 'Tính theo vàng mẹ (4)') {
                        if (goldContent == 99.9 || goldContent == 99.99) {
                            return weightGold * parentGoldPriceNumber || 0;
                        }
                        return 0;
                    } else {
                        return 0;
                    }
                };
                const value = e.purchasePriceRuleLine.find((line) => line.id);
                const timeRule = value?.timeRule?.hours ? value?.timeRule?.hours + ' giờ' : 'Không giới hạn (∞)';
                const ConditionOpts = [
                    {
                        code: 'time',
                        name: timeRule
                    },
                    {
                        code: 'time-value',
                        name: timeRule + (value?.isValue ? ' - ' + value?.fromValue + ' -> ' + (value?.toValue || '∞') : '')
                    },
                    {
                        code: 'size-inspection',
                        name: value?.fromSize + ' -> ' + (value?.toSize || '∞')
                    }
                ];

                const priceByRecipe = getPriceByRecipe() + wage;

                return {
                    ...item,
                    id: 0,
                    serialBatchNumber: e.serialNumber,
                    price: price,
                    priceCode: item.priceCode,
                    actionType: 'IN',
                    quantity: 1,
                    repurchaseRule: e.priceFormula,
                    ruleCode: e.ruleCode,
                    condition: ConditionOpts.find((el) => el.code == e.condition)?.name,
                    minimumValue: e.firstValues,
                    infoCustomer: [],
                    previousPrice: invoicePriceAfterCK, //Giá hoá đơn sau CK (kể cả voucher giảm %)
                    voucher: 0, // dòng trả không mang chiết khấu voucher của hóa đơn gốc
                    repurchaseRate: rateBuyChange, // % mua lại
                    repurchaseUnitPrice: priceByRecipe, //Đơn giá mua lại
                    repurchaseIncentive: 0, //Tiền ưu đãi mua lại - thu ngân nhập tay
                    totalDiscountRate: rateBuy, // % CK toàn bộ SP
                    totalCardRankValue: 0,
                    totalAmount: priceByRecipe, // Thành tiền
                    serialObj: item.serial?.length ? item.serial[0] : item.serial,
                    parentGoldCode: primaryGold || '', // Mã giá vàng mẹ
                    parentGoldPrice: parentGoldPriceNumber, //Giá vàng mẹ
                    goldPriceByCode: goldPriceCode, //Giá vàng theo mã giá
                    stonePrice: priceStoreAfterCK,
                    goldPriceDifference: 0,
                    labourPrice: wage,
                    totalStoneAmount: totalStoneAmount,
                    totalGoldAmount: totalGoldAmount,
                    currentPrice: this.formatPriceAndDateTime(goldPrices, 'buyPrice') //Giá MNVT9999 hiện tại
                };
            });
            itemOut.forEach((e) => {
                itemDetail.payload.itemDetail.push(e);
            });
        } catch (error) {
            console.log(error);
        }
    }

    //Xử lý mua hàng
    setProductPurchaseJewelry(item, priecGold, priceCodes, priceCodeTable, goldCodeTable, goldPriceBAC) {
        const product = item.Products.filter((e) => !item.payload.itemDetail.find((i) => i.index === e.index));
        item.payload.itemDetail.push(
            ...product.map((e) => {
                let priceFormula1 = '';
                const terms = item.payload.terms;
                const getPriceRule = () => {
                    if (terms == '1') {
                        priceFormula1 = e.rules?.priceFormula1 || '';
                        if (priceFormula1 == 'Giá thỏa thuận') {
                            return;
                        } else {
                            return e.rules.purchasePriceRuleLine1.find((line) => line.id && line.type == 'Mua hàng');
                        }
                    } else if (terms == '2') {
                        priceFormula1 = e.rules?.priceFormula2 || '';
                        return priceFormula1 == 'Giá thỏa thuận' ? null : e.rules.purchasePriceRuleLine2.find((line) => line.id && line.type == 'Mua hàng');
                    } else {
                        priceFormula1 = '';
                    }
                };
                const priceCodePurchase = getPriceRule() || {};
                let itemDatePriceCode = '';
                //Lấy giá vàng theo mã giá
                const getPrice = () => {
                    const res = goldCodeTable.find((line) => line.code == priceCodePurchase?.material);
                    if (res?.type == 'BAC') {
                        itemDatePriceCode = goldPriceBAC.date || '';
                        return goldPriceBAC.silverPriceLists?.find((line) => line.code == res?.id)?.priceBTMC || 0;
                    } else {
                        itemDatePriceCode = priecGold.date || '';
                        return priecGold.goldPriceListLine?.find((line) => line.goldCodeName == priceCodePurchase?.material)?.buyPrice || 0;
                    }
                };
                const itemPriceCode = getPrice() || 0;
                const priceCode = terms == '3' ? '' : priceCodePurchase?.material || '';
                //Tính công thức
                return {
                    itemId: e.id,
                    itemCode: e.itemCode,
                    itemName: e.itemName,
                    ugpEntry: e.ougp?.id || '',
                    ougp: e.ougp,
                    priceCodeDate: itemDatePriceCode || '',
                    stonePrice: 0,
                    weightGold: 0, //Trọng lượng vàng
                    goldRate: e.goldRate || e.goldContent?.rate || 0, //Hàm lượng vàng
                    quantity: 1,
                    index: e.index,
                    priceCode: priceCode,
                    manBtchNum: e.manBtchNum || '',
                    priceFormula1: priceFormula1 || '',
                    ruleCode: e.rules?.ruleCode || '',
                    price: itemPriceCode || 0,
                    isStonePrice: priceCodePurchase?.isStonePrice || false,
                    minusGoldContent: priceCodePurchase?.minusGoldContent || 0,
                    purchasePercent: priceCodePurchase?.purchasePercent || 0,
                    repurchaseIncentive: 0, //Tiền ưu đãi mua lại - thu ngân nhập tay
                    lineTotal: 0
                };
            })
        );
        item.payload.paymentMethod = [{ id: 0, fatherId: 0, paymentMethodCode: 'Cash', paymentMethodName: 'Tiền mặt', amount: 0 }];
    }

    setProductOrderJewelry(item, priecGold) {
        const itemSerial = item.payload.itemDetail.filter((el) => el.serialBatchNumber);
        const product = item.Products.filter((e) => !item.payload.itemDetail.find((i) => i.index === e.index));
        item.payload.itemDetail.push(
            ...product.map((e) => ({
                index: e.index,
                itemId: e.id,
                itemCode: e.itemCode,
                itemName: e.itemName,
                quantity: 1,
                ugpEntry: e.ougp.id, //Đơn vị tính
                priceManagement: e.priceListTypeCode || '', //Quản lý GB
                productRate: 0, //Tỷ lệ CK (sản phẩm)
                cardRankRate: 0, //Tỷ lệ CK (hạng thẻ)
                unitPriceAfterTransfer: 0, //Đơn giá sau CK
                lineTotal: 0, //Đơn giá SP
                reweighValueDifference: 0, //Chênh lệch giá trị
                totalCardRankValue: 0, //Tổng giá trị CK(hạng thẻ)
                totalPromotionValue: 0, //Tổng giá trị CK(CTKM)
                totalAmount: 0, //Thành tiền
                weightGold: 0, //Trọng lượng vàng
                goldRate: 0, //Hàm lượng vàng
                goldColor: '', //Màu sắc vàng
                ringSize: 0, //Size nhẫn
                length: 0, //Chiều dài (mm)
                stoneType: '', //Loại đá
                stoneWeight: 0, //Trọng lượng đá
                stonePrice: 0, //Giá đá
                stoneColor: '', //Màu đá
                stoneShape: '', //Hình dáng đá
                stoneSize: 0, //Kích thước đá
                cutStyle: '', //Kiểu mài
                images: [], //Hình ảnh
                note: '', //Ghi chú
                doC19: {
                    //Thông tin sản phẩm khách cho mượn (làm mẫu)
                    id: 0,
                    quantity: 0, // Số lượng
                    color: '',
                    weight: 0,
                    goldColor: '',
                    stoneSize: 0,
                    note: '',
                    images: []
                }
            }))
        );
        itemSerial.forEach((e) => {
            if (!item.payload.itemDetail.find((i) => i.serialBatchNumber === e.serialBatchNumber)) {
                item.payload.itemDetail.push(e);
            }
        });
        item.payload.paymentMethod = [{ id: 0, fatherId: 0, paymentMethodCode: 'Cash', methodStr: 'Tiền mặt', amount: item.payload.totalOrder - item.payload.paidDpm || 0 }];
    }
    //Cập nhật serial vào sản phẩm (Đặt hàng)
    async setSerialOrderJewelry(item, priecGold, priceCodes, priceCodeTable) {
        const itemOut = item.payload.itemDetail.filter((e) => e.actionType != 'OUT');
        const product = item.Products.filter((e) => e.serial && !item.payload.itemDetail.filter((i) => i.actionType == 'OUT').find((i) => i.serialBatchNumber === e.serial.serialNumber));
        item.payload.itemDetail.push(
            ...(await Promise.all(
                product.map(async (product) => {
                    if (!product.serial) return null;
                    const lineTotal = await this.getLineTotal(product, priecGold, priceCodes, priceCodeTable);
                    const price = this.getPrice(product, priecGold, priceCodes, priceCodeTable);

                    // Khởi tạo thông tin chi tiết cơ bản
                    delete product.serial.id;
                    const detail = this.createDetailObject(product, lineTotal, price, priecGold);

                    // Tính toán các giá trị chiết khấu và tổng tiền
                    const promotionValue = this.calculatePromotionValue(detail, lineTotal);
                    const priceAfterDiscount = this.calculatePriceAfterDiscount(lineTotal, detail, promotionValue);
                    const totalAmount = this.calculateTotalAmount(detail.quantity, priceAfterDiscount, detail.voucher);

                    //Tiền đá bán
                    const sellingStoneCost = (product.serial.originalWage || 0) * (product.serial.stoneCoefficient || 0) || 0;
                    //tiền công bán
                    const sellingLaborCost = (product.serial.labourAmount || 0) * (product.serial.workCoefficient || 0) || 0;

                    return {
                        ...detail,
                        totalPromotionValue: promotionValue,
                        unitPriceAfterTransfer: priceAfterDiscount,
                        sellingStoneCost,
                        sellingLaborCost,
                        totalAmount,
                        promotions: []
                    };
                })
            ).then((results) => results.filter(Boolean)))
        );

        // Cập nhật tổng tiền hóa đơn
        this.updateInvoiceTotal(item);
        this.initializePaymentMethod(item);
        itemOut.forEach((e) => {
            if (!item.payload.itemDetail.find((i) => i.index === e.index)) {
                item.payload.itemDetail.push(e);
            }
        });
    }

    /**
     * Lấy giá từ bảng giá theo mã
     */
    setPriceCodeTable(data, item, field, code = null, type = null) {
        const branchs = JSON.parse(localStorage.getItem('user'))?.appUser?.branchIds || [];
        const exchangeRate = this.getExchangeRate();

        const price = (data || [])
            .filter((table) => table.priceCodeTableType == type)
            .find((table) => table.scopes?.some((scope) => branchs.includes(scope)) || table.isAllBranch === true)
            ?.priceCodeTableLines?.find((line) => line.priceCode == code);
        if (field == 'sellingPrice') {
            if (!price) return 0;
            if (type === 'BAC') return price.sellingPrice || 0;
            return (price?.usdSellingPrice || 0) * exchangeRate;
        }
        return price ? price[field] : 0;
    }

    //Xử lý khuyến mãi
    setPromotionInvoiceJewelry(item, priecGold, priceCodes, priceCodeTable) {
        item.payload.itemDetail.map((e) => {
            e.productRate = 0;
            e.stonePriceRate = 0;
            e.laborCostRate = 0;
            e.promotions = [];
            e.totalPromotionValue = 0;
            e.totalCardRankValue = 0;
        });
        item.promotions.map((e) => {
            const itemDetail = item.payload.itemDetail.find((el) => el.serialBatchNumber == e.serial);
            if (itemDetail) {
                itemDetail.promotions.push({
                    index: e.index,
                    discount: e.rate,
                    promotionId: e.id,
                    promotionCode: e.promotionCode,
                    promotionName: e.promotionName,
                    promotionLineId: e.promotionLine[0].id,
                    typeDiscount: e.promotionLine[0].typeDiscount,
                    promotionAmount: e.promotionAmount,
                    serial: e.serial,
                    fromDate: e.fromDate,
                    toDate: e.toDate,
                    promotionType: e.promotionType,
                    promotionLine: e.promotionLine,
                    promotionSubType: e.promotionSubType,
                    cumulativeValueId: e.component,
                    itemId: e.itemId,
                    itemCode: e.itemCode,
                    itemName: e.itemName,
                    cardId: e.cardId,
                    cardCode: e.cardCode,
                    cardName: e.cardName,
                    appliedDate: new Date()
                });
                if (e.component == 3) {
                    itemDetail.stonePriceRate += e.rate;
                } else if (e.component == 4) {
                    itemDetail.laborCostRate += e.rate;
                } else {
                    itemDetail.productRate += e.rate;
                }
                if (e.promotionType == '4') {
                    itemDetail.totalCardRankValue += e.promotionAmount;
                }
                itemDetail.totalPromotionValue += e.promotionAmount;
                updateCalculatedValues(itemDetail);
            }
        });
    }
}

// Công thức tính đơn giá sau chuyển khoản = giá trị tính toán - tổng giá trị hạng thẻ - tổng giá trị khuyến mãi + chênh lệch giá trị
const calculateUnitPriceAfterTransfer = (data) => {
    return data.lineTotal - (data.totalPromotionValue || 0) + (data.reweighValueDifference || 0);
};

// Cập nhật các giá trị đã tính toán
const updateCalculatedValues = (data) => {
    // Đảm bảo các giá trị không bị undefined
    data.lineTotal = data.lineTotal || 0;
    data.reweighValueDifference = data.reweighValueDifference || 0;
    data.totalPromotionValue = data.totalPromotionValue || 0;
    data.voucher = 0;
    // Tính toán giá trị mới
    const newUnitPrice = calculateUnitPriceAfterTransfer(data);

    // Cập nhật đồng thời cả 2 giá trị
    data.unitPriceAfterTransfer = newUnitPrice;
    data.totalAmount = newUnitPrice;
};

export default ServiceTrading;
